module.exports = __webpack_public_path__ + "static/media/productivityInActive.9d30f4b9.svg";